import React, { useEffect, useState, FormEvent } from 'react';
import { Modal } from 'react-bootstrap';
import { Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import userStore from '../../store/userStore';
import toast from '../../components/toast';
import groupServices from '../../services/groupServices';
import userService from '../../services/userService';
import constants from '../../config/constants';
import authStore from '../../store/authStore';
import PlusBtn from '../../assets/add.png';
import NoSensorBoxSelected from '../../assets/sensor_empty.png';
import Close from '../../assets/close.png';
import Select from '../../components/select';
import './CreateGroupModal.css';
import  Permissions from '../../config/permssions'
import sensorboxGroupService from '../../services/sensorboxGroupService';
import AlertRecipientsCard from '../AlertRecipientsCard';
import { mergeTeamRecipients, splitTeamRecipients, AlertRecipient } from '../../utils/alertRecipients';

const {
  view_contractor_sensorboxes_assets,
  view_assigned_users_sensorboxes_assets,
  create_or_update_sensorboxes_assets,
  delete_sensorboxes_assets,
  view_only_partial_asset_sensorbox_details
} = Permissions

interface Props {
  show: boolean;
  group?: any;
  editMode?: boolean;
  onClose: () => void;
  onSave?: () => void;
  onDelete?: () => void;
  // note : temp solution for the org admin access to all org
  organisationId? :   any;
}
// note : temp solution for the org admin access to all org
const CreateGroupModal: React.FC<Props> = ({ show, onClose, group, editMode, onSave, onDelete ,organisationId }) => {

  const [sensorboxList, setSensorboxList] = useState<Array<any>>([]);
  const [contractorList, setContractorList] = useState<Array<any>>([]);
  const [consumerList, setConsumerList] = useState<Array<any>>([]);
  const [formData ,setFormData] =useState<any>({})
  const [name, setName] = useState('');
  const [locDetails, setLocDetails] = useState('');
  const [sensorboxes, setSensorboxes] = useState<Array<any>>([]);
  const [mergeTimeout, setMergeTimeout] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [processing, setProcessing] = useState(false);
  const [editConsumer, setEditConsumer] = useState(false);
  const [editContractor, setEditContractor] = useState(false);
  const [userAccess ,setUserAccess] = useState<any>([]);
  const [errors, setErrors] = useState<any>({});
  const [attachments, setAttachments] = useState<any[]>([]);
  const [externalLinks, setExternalLinks] = useState<any[]>([]);
  const [selectedLinkType, setSelectedLinkType] = useState('model');
  const [currentLinkName, setCurrentLinkName] = useState('');
  const [currentLinkUrl, setCurrentLinkUrl] = useState('');

  useEffect(()=> {
    if(show) {
      if(group) {
        setName(group?.name);
        setLocDetails(group?.loc_details || '');
        setFormData(group)
        setSensorboxes(group?.sensorboxes);
        setMergeTimeout(group?.group_merge_timeout);
        setAttachments(group?.attachments || []);
        setExternalLinks(group?.external_reference_links || []);
        
        // If in edit mode and group has an ID, fetch the complete group data
        if(editMode && group?._id) {
          fetchSensorboxGroupDetails();
        }
      }
      fetchSensorboxes();
      getCustomerList()
      getContractorList()
    }else{
      clear();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, group]);


  const clear = () => {
    setName('');
    setLocDetails('');
    setMergeTimeout('');
    setSensorboxes([]);
    setFormData({})
    setEditConsumer(false)
    setEditContractor(false)
    setErrors({});
    setSearchKeyword('');
    setAttachments([]);
    setExternalLinks([]);
    setSelectedLinkType('model');
    setCurrentLinkName('');
    setCurrentLinkUrl('');
  }
  

  const fetchSensorboxes = async () => {
    try {
      // note : temp solution for the org admin access to all org
      const resp = await groupServices.getSensorboxesForGroup(organisationId);
      if(resp) {
        let data = resp.data;
        if(group) {
          data = [ ...group?.sensorboxes, ...data ];
        }
        setSensorboxList(data);
      }
    } catch (error: any) {
      let errMsg = error?.message;
      if(error?.response?.data?.message) {
        errMsg = error?.response?.data?.message
      }
      toast.error(errMsg);
    }
  }

  const isGroupNameExist = async () => {
    if(!name?.trim()) return;
    try {
      // note : temp solution for the org admin access to all org
      const resp = await groupServices.isGroupNameExist(name, group?._id , organisationId);
      const { group_exist_status } = resp.data;
      let errorMsg = group_exist_status ? constants.message.group_name_exists : '';  
      setErrors((prev: any) => ({...prev, name: errorMsg }));
      return group_exist_status;
    } catch (error: any) {}
  }

  const getContractorList = async () => {       
    try{
        let contractorList = []
        let selectedItem;
        if(authStore?.currentUser?.access?.includes(view_contractor_sensorboxes_assets)) {
          selectedItem = {_id : authStore.currentUser.uid, name : authStore.currentUser.name}
          setContractorList([selectedItem])
        }else if(authStore?.currentUser?.access?.includes(view_assigned_users_sensorboxes_assets)){
            selectedItem = userStore.profileDetials && userStore.profileDetials.assigned_to;
            setContractorList([selectedItem])
        }else{
          // note : temp solution for the org admin access to all org
            let orgid = ''
            if(group?.org_id){
              orgid = group?.org_id
            }else{
              orgid = organisationId
            }
            contractorList = await userService.getContractorList(orgid)
            setContractorList(contractorList)
        }                        
    }catch(error: any){
        toast.error(error.response.data.message)
    } 
  }

  const getCustomerList = async()  =>{     
    try{
      // note : temp solution for the org admin access to all org
      let orgid = ''
      if(group?.org_id){
        orgid = group?.org_id
      }else{
        orgid = organisationId
      }
        let consumerList = await userService.getCustomerList(orgid)
        setConsumerList(consumerList)
        if(group?.user_access){
          const userAccessArray = consumerList?.filter((item:any)=>(
            group?.user_access?.includes(item?._id)
          ))  
          const filteredUserAccess = userAccessArray?.map((item:any)=>({value:item._id,label:item.name})) 
          setUserAccess(filteredUserAccess)
        }

    }catch(error: any){
        toast.error(error.response.data.message)
    }       
  }

  const createGroup = async (e: FormEvent<HTMLFormElement>)=> {
    e.preventDefault();
    try {
      if(validate()) return false;
      
      const isNameExist = await isGroupNameExist();
      if(isNameExist) return false;

      const userAccesValue = userAccess?.map((item :any) => item.value)
      const uniqueConsumers = Array.from(new Map(
          sensorboxes.flatMap(box => box.consumer || []).map(c => [c._id, c])
        ).values());
      const uniqueContractors = Array.from(new Map(
          sensorboxes.flatMap(box => box.contractor || []).map(c => [c._id, c])
        ).values());
      const uniqueMobileConsumers = Array.from(new Map(
          sensorboxes.flatMap(box => box.mobile_consumer || []).map(c => [c._id, c])
        ).values());
      const uniqueMobileContractors = Array.from(new Map(
          sensorboxes.flatMap(box => box.mobile_contractor || []).map(c => [c._id, c])
        ).values());

      const uniqueVoiceConsumers = Array.from(new Map(
          sensorboxes.flatMap(box => box.voice_consumer || []).map(c => [c._id, c])
        ).values());
      const uniqueVoiceContractors = Array.from(new Map(
          sensorboxes.flatMap(box => box.voice_contractor || []).map(c => [c._id, c])
        ).values());

      const params = {
        name,
        loc_details: locDetails,
        sensorboxes: sensorboxes.map(s => s?._id),
        group_merge_timeout: parseInt(mergeTimeout),
        consumer: editMode ? formData?.consumer : uniqueConsumers,
        contractor: editMode ? formData?.contractor : uniqueContractors,
        mobile_consumer: editMode ? formData?.mobile_consumer : uniqueMobileConsumers,
        mobile_contractor: editMode ? formData?.mobile_contractor : uniqueMobileContractors,
        voice_consumer: editMode ? formData?.voice_consumer : uniqueVoiceConsumers,
        voice_contractor: editMode ? formData?.voice_contractor : uniqueVoiceContractors,
        user_access : editMode ? userAccesValue : userAccesValue,
        external_reference_links: externalLinks,
        attachments: attachments
      }
      setProcessing(true);
      if(editMode) {
        // note : temp solution for the org admin access to all org
        await groupServices.editGroup(group?._id, params , organisationId);
        
      }else {
        // note : temp solution for the org admin access to all org
        await groupServices.createGroups(params, organisationId);
      }
      setProcessing(false);
      onClose()
      if(onSave) onSave();
    } catch (error: any) {
      setProcessing(false);
      let errMsg = error?.message;
      if(error?.response?.data?.message) {
        errMsg = error?.response?.data?.message
      }
      toast.error(errMsg);
    }
  }

  const onChooseSensorbox = (sensorbox: any) => {
    clearFieldError('sensorboxes')
    if(searchKeyword) setSearchKeyword(''); // clear the searchbox after selection
    setSensorboxes((prev) => [...prev, sensorbox])
  }

  const clearFieldError = (field: string) => {
    if(errors[field]) {
      setErrors((prev: any) => ({ ...prev, [field]: ''}))
    }
  }

  const handleConsumerRecipientsChange = (recipients: AlertRecipient[]) => {
    const split = splitTeamRecipients(recipients);
    setFormData((prevState: any) => ({
      ...prevState,
      consumer: split.email,
      mobile_consumer: split.sms,
      voice_consumer: split.voice,
    }));
  };

  const handleContractorRecipientsChange = (recipients: AlertRecipient[]) => {
    const split = splitTeamRecipients(recipients);
    setFormData((prevState: any) => ({
      ...prevState,
      contractor: split.email,
      mobile_contractor: split.sms,
      voice_contractor: split.voice,
    }));
  };

  const handleContractorSelection = (option: any) => {
    clearFieldError('contractor')
    setFormData((prevState :any )=> ({
        ...prevState,
        'contractor': convertDropdownData(option,'r')
    }));
  }

  const handleConsumerSelection = (option: any) => {
    clearFieldError('consumer')
    setFormData((prevState :any )=> ({
        ...prevState,
        'consumer': convertDropdownData(option,'r')
    }));
  }

  const handleMobileContractorSelection = (option: any) => {
    clearFieldError('mobile_contractor')
    setFormData((prevState :any )=> ({
        ...prevState,
        'mobile_contractor': convertDropdownData(option,'r')
    }));
  }

  const handleMobileConsumerSelection = (option: any) => {
    clearFieldError('mobile_consumer')
    setFormData((prevState :any )=> ({
        ...prevState,
        'mobile_consumer': convertDropdownData(option,'r')
    }));
  }

  const validate = () => {
    const errors: any = {};
    if(!name?.trim()) {
      errors.name = constants.message.group_name_mandatory;
    }

    if(!mergeTimeout) {
      errors.group_merge_timeout = constants.message.group_merge_timeout_required;
    }else if(parseInt(mergeTimeout) < 1 || parseInt(mergeTimeout) > 60) {
      errors.group_merge_timeout = constants.message.group_merge_timeout_valid_range;
    }

    if(sensorboxes?.length < 1 ) {
      errors.sensorboxes = constants.message.group_sensorboxes_min
    }

    if (locDetails && locDetails.length > 150) {
      errors.loc_details = 'Location details cannot exceed 150 characters';
    }

    setErrors(errors);
    return Object.keys(errors).some(field => field !== '')
  }

  const removeSensorbox = (sensorbox: any) => {
    const updated = sensorboxes.filter(s => s?._id !== sensorbox?._id);
    setSensorboxes(updated);
  }


  let list = sensorboxList.filter(s => (sensorboxes.findIndex(sb => sb?._id === s?._id) < 0) );
  if(searchKeyword) {
    const skw= searchKeyword.toLowerCase()
    list = list?.filter(s => s?.sensor_box_name?.toLowerCase().includes(skw) ||
    s?.alias?.toLowerCase().includes(skw) ||
      s?.consumer?.some((i:any)=>i?.name.toLowerCase().includes(skw)) ||
        s?.contractor?.some((i:any)=>i?.name.toLowerCase().includes(skw))
    )
  }

  const listClassName = ['sensorbox-list p-0']
  const sensorBoxClassName = ['d-flex align-items-center bg-light rounded p-2 mb-2 mr-2']
  if(!authStore?.currentUser?.access?.includes(create_or_update_sensorboxes_assets)){
    listClassName.push('group-disabled')
    sensorBoxClassName.push('group-disabled')
  }

  const handleEditConsumer = (event : any) => {
    setEditConsumer(event.target.checked)
  }

  const handleEditContractor = (event : any) => {
    setEditContractor(event.target.checked)
  }

  const customerData = (customers : any) => {

    let filteredUsers = customers?.filter((customer : any) => {
      const role = customer?.roles?.filter((role : any) => role?.role_type > 1)
      return role.length > 0
    })

    return filteredUsers
  }

  const demoCheck = (authStore?.currentUser?.active_role?.role_type === -1);

  const handleUserAccessSelection  = (option : any) => {
    setUserAccess(option)
  };
  const convertDropdownData = (data:any, direction:string)=>{
    switch (direction){
      case 'f': return data?.map((i:any)=>({value: i?._id,label: i?.name}))?? []
      case 'r': return data?.map((i:any)=>({_id:i?.value,name:i?.label}))?? []
    }
  }

  const handleAddExternalLink = () => {
    if (!authStore?.isOrgAdmin()) {
      return;
    }

    if (!currentLinkName.trim() || !currentLinkUrl.trim()) {
      toast.error('Please enter both name and URL');
      return;
    }

    // Validate URL format
    try {
      new URL(currentLinkUrl);
    } catch {
      toast.error('Please enter a valid URL');
      return;
    }

    // Always add to local state - will be saved when Save button is clicked
    const newLink = {
      type: selectedLinkType,
      name: currentLinkName.trim(),
      url: currentLinkUrl.trim()
    };
    setExternalLinks(prev => [...prev, newLink]);
    setCurrentLinkName('');
    setCurrentLinkUrl('');
  }

  const handleDeleteExternalLink = (linkIndex: number) => {
    // Always remove from local state - will be saved when Save button is clicked
    setExternalLinks(prev => prev.filter((_, index) => index !== linkIndex));
  }

  const fetchSensorboxGroupDetails = async () => {
    if (!group?._id) return;
    
    try {
      const response = await sensorboxGroupService.getSensorboxGroupById(group._id, organisationId);
      if (response?.status === 200 && response?.data) {
        setAttachments(response.data.attachments || []);
        setExternalLinks(response.data.external_reference_links || []);
        setLocDetails(response.data.loc_details || '');
      }
    } catch (error: any) {
      console.error('Error fetching group details:', error);
    }
  }

  return (
    <>
    <Modal
      show={show}
      onHide={onClose}
      className="create-group-modal"
      backdrop="static"
    >
      <Modal.Header className="py-2 px-3" closeButton>

      {editMode ? authStore?.currentUser?.access?.includes(view_only_partial_asset_sensorbox_details) ? 'View Asset Details' :  !authStore?.currentUser?.access?.includes(create_or_update_sensorboxes_assets) ? name : 'Edit Asset' : 'Create Asset'}
      </Modal.Header>
      <Modal.Body>
        <div className="" id="create-group-modal-body">
          <form onSubmit={createGroup}>
            <div className="mb-2">
              <label htmlFor="">Name <span className="mand-star">*</span></label>
              <input 
                className="form-control"
                type="text"
                placeholder="Enter name"
                value={name}
                disabled = {!authStore?.currentUser?.access?.includes(create_or_update_sensorboxes_assets) || authStore?.currentUser?.access?.includes(view_only_partial_asset_sensorbox_details)}
                onChange={(e)=>{
                  clearFieldError('name');
                  setName(e.target.value);
                }}
                onBlur={isGroupNameExist}
                maxLength={50}
              />
              <div className="error-msg">{errors?.name}</div>
            </div>
            <div className="mb-2">
              <label htmlFor="">Asset merge timeout (1-60) minute <span className="mand-star">*</span></label>
              <input
                type="number"
                className="form-control"
                placeholder="Enter timeout (1-60) minute"
                value={mergeTimeout}
                disabled = {!authStore?.currentUser?.access?.includes(create_or_update_sensorboxes_assets) || authStore?.currentUser?.access?.includes(view_only_partial_asset_sensorbox_details)}
                onChange={(e)=> {
                  clearFieldError('group_merge_timeout');
                  setMergeTimeout(e.target.value)
                }}
                max={60}
                min={1}
              />
              <div className="error-msg">{errors?.group_merge_timeout}</div>
            </div>
            <div className="mb-2">
              <label className="custom-label" htmlFor="loc_details">
                Location details{' '}
                <Tooltip title="This info will be used in alert email" trigger={['hover', 'click']}>
                  <InfoCircleOutlined
                    style={{ marginLeft: 4, color: '#8c8c8c', fontSize: 13, cursor: 'help' }}
                    onClick={(e) => e.preventDefault()}
                  />
                </Tooltip>
              </label>
              <input
                type="text"
                className="form-control"
                id="loc_details"
                name="loc_details"
                maxLength={150}
                placeholder="Enter location details (Max 150 characters)"
                value={locDetails}
                disabled={!authStore?.currentUser?.access?.includes(create_or_update_sensorboxes_assets) || authStore?.currentUser?.access?.includes(view_only_partial_asset_sensorbox_details)}
                onChange={(e) => {
                  clearFieldError('loc_details');
                  setLocDetails(e.target.value);
                }}
              />
              <div className="error-msg">{errors?.loc_details}</div>
            </div>
          { editMode && 
            <div className="row">
              {!authStore?.currentUser?.access?.includes(view_only_partial_asset_sensorbox_details) && (
                <div className="col-md-6 mb-3">
                  <div className="edit-role-group mb-2">
                    <input
                      type="checkbox"
                      className="mr-2"
                      disabled={demoCheck}
                      checked={editContractor}
                      onChange={handleEditContractor}
                    />
                    <label className="custom-label">Edit Team Member(s)</label>
                  </div>
                  <AlertRecipientsCard
                    title="Property mgmt / service provider team"
                    recipients={demoCheck ? [] : mergeTeamRecipients(
                      formData?.contractor,
                      formData?.mobile_contractor,
                      formData?.voice_contractor
                    )}
                    availableUsers={(contractorList || []) as Array<{ _id: string; name: string }>}
                    disabled={!authStore?.currentUser?.access?.includes(create_or_update_sensorboxes_assets) || !editContractor}
                    onChange={handleContractorRecipientsChange}
                  />
                </div>
              )}
              <div className={authStore?.currentUser?.access?.includes(view_only_partial_asset_sensorbox_details) ? 'col-md-12 mb-3' : 'col-md-6 mb-3'}>
                {!authStore?.currentUser?.access?.includes(view_only_partial_asset_sensorbox_details) && (
                  <div className="edit-role-group mb-2">
                    <input
                      type="checkbox"
                      className="mr-2"
                      disabled={demoCheck}
                      checked={editConsumer}
                      onChange={handleEditConsumer}
                    />
                    <label className="custom-label">Edit Consumer Team</label>
                  </div>
                )}
                <AlertRecipientsCard
                  title="Consumer and team"
                  recipients={demoCheck ? [] : mergeTeamRecipients(
                    formData?.consumer,
                    formData?.mobile_consumer,
                    formData?.voice_consumer
                  )}
                  availableUsers={(consumerList || []) as Array<{ _id: string; name: string }>}
                  disabled={!authStore?.currentUser?.access?.includes(create_or_update_sensorboxes_assets) || !editConsumer}
                  onChange={handleConsumerRecipientsChange}
                />
              </div>
            </div>
          }

            <div className="mb-4">
              {authStore?.currentUser?.access?.includes(view_only_partial_asset_sensorbox_details) ?
              <label htmlFor="">Sensor boxes <span className="mand-star">*</span></label>
              :
              <label htmlFor="">Add sensor boxes <span className="mand-star">*</span></label>
              }
              <div className="border rounded">
                <div className="row no-gutters">
                  {!authStore?.currentUser?.access?.includes(view_only_partial_asset_sensorbox_details) &&
                  <div className="col-5 border-right">
                    <div className="border-bottom ">
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control border-0 rounded-0"
                        value={searchKeyword || ''}
                        disabled = { !authStore?.currentUser?.access?.includes(create_or_update_sensorboxes_assets)}
                        onChange={(e) => setSearchKeyword(e.target.value)}
                        onKeyDown={(e) => {
                          if(e.which === 13) {
                            e.preventDefault()
                          }
                        }}
                      />
                    </div>
              
                    <ul className={listClassName.join(' ')}>
                      {
                        list.map((sensorbox: any) => (
                          <li key={sensorbox?._id} className="sensorbox-list-item" onClick={()=> onChooseSensorbox(sensorbox)}>
                            <img className="mr-2" src={PlusBtn} style={{height: 12}} alt=''/>
                            <span>{sensorbox?.sensor_box_name}</span>{sensorbox?.alias && <span className='text-truncate'>&nbsp;&nbsp;( {sensorbox?.alias} )</span>}
                          </li>
                        ))
                      }
                      {
                       (list.length === 0) &&
                        <li className="text-center py-5 text-secondary">
                          No sensor boxes
                        </li>
                      }
                    </ul>
                
                  </div>
                  }
                  <div className={!authStore?.currentUser?.access?.includes(view_only_partial_asset_sensorbox_details) ? "col-7" : "col-12"}>
                      {
                        sensorboxes?.length === 0 && (
                          <div className="d-flex h-100 p-3">
                            <div className="m-auto text-center">
                              <img className="mb-2" src={NoSensorBoxSelected} height={48} alt=''/>
                              <p className="m-0 text-secondary">No sensor boxes 
                              <br/>{!authStore?.currentUser?.access?.includes(view_only_partial_asset_sensorbox_details) ? 'selected' : ''}</p>
                            </div>
                          </div>
                        )
                      }
                      <div className="d-flex flex-wrap p-3">
                        {
                          sensorboxes?.map((sensorbox: any) => (
                            <div key={sensorbox?._id} className={sensorBoxClassName.join(' ')}>
                              {sensorbox?.sensor_box_name}
                              <img
                                src={!authStore?.currentUser?.access?.includes(view_only_partial_asset_sensorbox_details) ? Close : ''}
                                className={!authStore?.currentUser?.access?.includes(view_only_partial_asset_sensorbox_details) ? "ml-2 cursor-pointer" : "ml-2"}
                                height="10"
                                onClick={() => removeSensorbox(sensorbox)}
                                alt=''
                              />
                            </div>
                          ))
                        }
                      </div>
                  
                  </div>
                </div>
              </div>
              {errors?.sensorboxes && <div className="error-msg">{errors?.sensorboxes}</div>}
            </div>

            
            <div className="row">
              {!authStore?.currentUser?.access?.includes(view_only_partial_asset_sensorbox_details) &&
                <div className="col-md-12">
                                <div className="input-text-field">
                                    <div className="form-group">
                                        <label className="custom-label"> User Access </label>
                                            <Select 
                                                isMulti = {true}
                                                name="useraccess"
                                                isDisabled={!authStore?.currentUser?.access?.includes(create_or_update_sensorboxes_assets)}
                                                data={ customerData(consumerList) }
                                                value={demoCheck ? '' : userAccess}
                                                onChange={(option :any) => handleUserAccessSelection(option)}
                                                maxOptions={15}
                                            />
                                    </div>
                                </div>
                </div>
              }
            </div>

            {/* External Reference Links Section */}
            {(authStore?.isOrgAdmin()) && (
              <div className="mb-4">
                <label htmlFor="">External Reference Links</label>
                <div className="border rounded">
                  <div className="row no-gutters">
                    <div className="col-12">
                      <div className="border-bottom p-3">
                        <div className="row">
                          <div className="col-md-4">
                            <label className="custom-label">Type</label>
                            <select 
                              className="form-control"
                              value={selectedLinkType}
                              disabled={!authStore?.currentUser?.access?.includes(create_or_update_sensorboxes_assets) || authStore?.currentUser?.access?.includes(view_only_partial_asset_sensorbox_details)}
                              onChange={(e) => setSelectedLinkType(e.target.value)}
                            >
                              <option value="model">Model</option>
                              <option value="before_install">Before Install</option>
                              <option value="after_install">After Install</option>
                              <option value="miscellaneous">Miscellaneous</option>
                            </select>
                          </div>
                          <div className="col-md-3">
                            <label className="custom-label">Name</label>
                            <input 
                              type="text"
                              className="form-control"
                              placeholder="Enter Name"
                              value={currentLinkName}
                              onChange={(e) => setCurrentLinkName(e.target.value)}
                              disabled={!authStore?.currentUser?.access?.includes(create_or_update_sensorboxes_assets) || authStore?.currentUser?.access?.includes(view_only_partial_asset_sensorbox_details)}
                            />
                          </div>
                          <div className="col-md-4">
                            <label className="custom-label">URL</label>
                            <input 
                              type="url"
                              className="form-control"
                              placeholder="Enter URL"
                              value={currentLinkUrl}
                              onChange={(e) => setCurrentLinkUrl(e.target.value)}
                              disabled={!authStore?.currentUser?.access?.includes(create_or_update_sensorboxes_assets) || authStore?.currentUser?.access?.includes(view_only_partial_asset_sensorbox_details)}
                            />
                          </div>
                          <div className="col-md-1 d-flex align-items-end">
                            <button 
                              type="button"
                              className="btn btn-primary btn-sm"
                              disabled={!authStore?.currentUser?.access?.includes(create_or_update_sensorboxes_assets) || authStore?.currentUser?.access?.includes(view_only_partial_asset_sensorbox_details)}
                              onClick={handleAddExternalLink}
                            >
                              +
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="p-3">
                        {externalLinks.filter(link => link.type === selectedLinkType).length === 0 ? (
                          <div className="text-center py-3 text-secondary">
                            No links for {selectedLinkType}
                          </div>
                        ) : (
                          <div>
                            {externalLinks.filter(link => link.type === selectedLinkType).map((link, index) => {
                              const globalIndex = externalLinks.findIndex(l => l === link);
                              return (
                                <div key={index} className="d-flex align-item-start justify-content-between bg-light rounded p-2 mb-2">
                                  <div className="flex-grow-1">
                                    <div className="font-weight-bold">{link.name}</div>
                                    <div className="text-muted small">
                                      <a 
                                        href={link.url} 
                                        target="_blank" 
                                        rel="noopener noreferrer"
                                        className="text-primary"
                                        style={{ textDecoration: 'underline' }}
                                      >
                                        {link.url}
                                      </a>
                                    </div>
                                  </div>
                                  {!authStore?.currentUser?.access?.includes(view_only_partial_asset_sensorbox_details) && (
                                    <img
                                      src={Close}
                                      className="ml-2 cursor-pointer"
                                      height="10"
                                      onClick={() => handleDeleteExternalLink(globalIndex)}
                                      alt=''
                                    />
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
 
            {!authStore?.currentUser?.access?.includes(view_only_partial_asset_sensorbox_details) &&
            <button
              className="btn btn-primary btn-sm rounded-0 btn-dark-blue"
              disabled={processing || demoCheck}
            >
              {editMode ? 'Save' : 'Create'}
            </button>
            } 
            {
              editMode && authStore?.currentUser?.access?.includes(delete_sensorboxes_assets) && !authStore?.currentUser?.access?.includes(view_only_partial_asset_sensorbox_details) &&
              <button 
                className="btn bg-white btn-sm rounded-0 ml-3"
                disabled={demoCheck}
                onClick={(e) => {
                  e.preventDefault();
                  if(onDelete) onDelete()
                }}
              >
                <span className="text-secondary">Delete</span> 
              </button>
            }
          </form>
          
        </div>
      </Modal.Body>
    </Modal>
  </>
  )
}

export default CreateGroupModal;

